import React from 'react'
import useDimensions from 'react-use-dimensions'
import { Player } from 'video-react'
import { useInViewPort } from 'landing/utils'

import {
  Box,
  DesktopBlock,
  PositionBox,
} from 'landing/kit'

import videoStub from './video-stub.png'

export const VideoSection = ({src}) => {
  const playerRef = React.createRef<HTMLElement>()
  const [play, setPlay] = React.useState<Boolean>(false)
  const [containerRef, containerSize] = useDimensions()
  const [nodeRef, isVisible] = useInViewPort()

  const playVideo = React.useCallback(() => {
    setPlay(true)
    setTimeout(() => {
      playerRef.current?.play()

      if (containerSize.width < 500) {
        playerRef.current?.toggleFullscreen()
      }
    }, 50)
  }, [playerRef])


  return (
    <PositionBox
      width="100%"
      maxWidth={378}
      marginBottom={{xs: '-75px', lg: 0}}
      css={{ position: 'relative' }}
    >
      <DesktopBlock
        display={!play ? 'block' : 'none'}
        onClick={() => playVideo()}
        css={{
          cursor: 'pointer'
        }}>
         <Box as="img" src={videoStub} width="100%" />
      </DesktopBlock>
      <DesktopBlock display={play ? 'block' : 'none'} ref={nodeRef}>
        {isVisible && (
          <Player
            ref={playerRef}
            preload={true}
            autoPlay={true}
            src={src}
          />
        )}
      </DesktopBlock>
    </PositionBox>
  )
}

export default VideoSection
